import React from 'react';
import { Badge } from './badge';
import { cn } from '../../lib/utils';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export const Section: React.FC<SectionProps> = ({ children, className = "", id }) => {
  return (
    <section id={id} className={cn("relative py-24 md:py-32 px-6 overflow-hidden", className)}>
      <div className="max-w-6xl mx-auto relative z-10">
        {children}
      </div>
    </section>
  );
};

interface SectionHeaderProps {
  badge?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  lightText?: boolean;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  badge, 
  title, 
  description, 
  align = 'center',
  lightText = false
}) => {
  const textColor = lightText ? 'text-primary-foreground' : 'text-foreground';
  const mutedColor = lightText ? 'text-primary-foreground/70' : 'text-muted-foreground';
  
  return (
    <div className={cn("mb-20 space-y-4", align === 'center' ? 'text-center' : 'text-left')}>
      {badge && (
        <Badge variant={lightText ? "secondary" : "outline"} className="mb-4">
          {badge}
        </Badge>
      )}
      <h2 className={cn("font-display font-semibold tracking-tight leading-[1.1] text-[clamp(2rem,4vw+0.5rem,3rem)]", textColor)}>
        {title}
      </h2>
      {description && (
        <p className={cn("font-serif font-normal leading-relaxed max-w-[60ch] text-lg md:text-xl", mutedColor, align === 'center' ? 'mx-auto' : '')}>
          {description}
        </p>
      )}
    </div>
  );
};